
<template>
  <div>
    <sp-select
      theme="team"
      :required="true"
      v-model="selectGovernorate"
      :options="governorate"
      :selected="selectedgovernorate"
      name="governorate"
      id="governorate"
      placeholder="Gouvernorat"
      :label="$t('company.governorate')"
      class="mb-5"
    ></sp-select>

    <sp-select
      v-if="delegation.length>0"
      theme="team"
      :required="true"
      :label="$t('company.delegation')"
      v-model="selectDelegation"
      :options="delegation"
      :selected="selecteddelegation"
      name="delegation"
      id="delegation"
      placeholder="delegation"
      class="mb-5"
    ></sp-select>
  </div>
</template>

<script>
import SelectVue from "./Select.vue";
import { localityList } from "@/common/data";

export default {
  name: "sp-delegation-list",
  components: {
    "sp-select": SelectVue
  },
  props: {
    selectedgovernorate: {
      required: false,
      type: String,
      default: null
    },
    selecteddelegation: {
      required: false,
      type: String,
      default: null
    },
    edited: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    selectGovernorate(val) {
      if (val && this.edited == false) {
        let keysSectors = this.data[val];
        this.delegation = [];
        let i = 0;
        Array.prototype.forEach.call(keysSectors, key => {
          this.delegation.push({ name: key, value: i });
          i++;
        });
        this.$emit("select-change", ["governorate", val]);
      }
      //this.$emit("edit-change-deleg",false);
    },
    selectDelegation(val) {
      this.$emit("select-change", ["delegation", val]);
    },
    selectedgovernorate(val) {
      this.selectGovernorate = val;
      let keysSectors = this.data[val];
      this.delegation = [];
      let i = 0;
      Array.prototype.forEach.call(keysSectors, key => {
        this.delegation.push({ name: key, value: i });
        i++;
      });
    }
  },

  data() {
    return {
      selectGovernorate: null,
      selectDelegation: null,
      delegation: [],
      governorate: [
        { name: "TUNIS", value: "1" },
        { name: "ARIANA", value: "2" },
        { name: "BEN AROUS", value: "3" },
        { name: "MANNOUBA", value: "4" },
        { name: "NABEUL", value: "5" },
        { name: "ZAGHOUAN", value: "6" },
        { name: "BIZERTE", value: "7" },
        { name: "BEJA", value: "8" },
        { name: "JENDOUBA", value: "9" },
        { name: "LE KEF", value: "10" },
        { name: "SILIANA", value: "11" },
        { name: "KAIROUAN", value: "12" },
        { name: "KASSERINE", value: "13" },
        { name: "SIDI BOUZID", value: "14" },
        { name: "SOUSSE", value: "15" },
        { name: "MONASTIR", value: "16" },
        { name: "MAHDIA", value: "17" },
        { name: "SFAX", value: "18" },
        { name: "GAFSA", value: "19" },
        { name: "TOZEUR", value: "20" },
        { name: "KEBILI", value: "21" },
        { name: "GABES", value: "22" },
        { name: "MEDENINE", value: "23" },
        { name: "TATAOUINE", value: "24" }
      ],
      data: localityList().data
    };
  }
};
</script>

<style>
</style>
